<ul
  class="dropdown-menu"
  DMClickOutside
  (clickOutside)="clearContainer()"
  [style.top]="(position | async)?.y + 'px'"
  [style.left]="(position | async)?.x + 'px'"
  [style.width]="(width | async) + 'px'"
  [style.display]="'block'"
>
  <li
    *ngFor="let option of selectOptions$ | async; trackBy: trackByValue"
    class="dropdown-menu-item"
    [class.selected]="option.selected"
    [class.hidden]="option.hidden"
  >
    <a (click)="setValue(option.value)">
      {{ option.text | translate }}
      <xux-icon *ngIf="icon && !!showIcon && showIcon(option.value)" [icon]="icon"></xux-icon>
    </a>
  </li>
</ul>
